/** Minhas operações: o que o usuário enviou para aprovação pelos Entregáveis. */

import { TabelaEnvios } from "@/components/aprovacoes/TabelaEnvios";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useMinhasOperacoes } from "@/hooks/queries";

export function MinhasOperacoesPage() {
  const { data: envios, isLoading } = useMinhasOperacoes();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Minhas operações</CardTitle>
        <CardDescription>
          Operações que você enviou para aprovação, da mais recente para a mais
          antiga. Passe o mouse sobre uma classificação para ver quem decidiu e
          o comentário.
        </CardDescription>
      </CardHeader>

      <CardContent>
        {isLoading || !envios ? (
          <Skeleton className="h-40 w-full" />
        ) : envios.length === 0 ? (
          <p className="py-8 text-center text-sm text-muted-foreground">
            Nenhuma operação enviada ainda.
          </p>
        ) : (
          <TabelaEnvios
            envios={envios}
            origem={{ para: "/minhas-operacoes", rotulo: "Minhas operações" }}
            autorRemove
          />
        )}
      </CardContent>
    </Card>
  );
}
